import React, { useState } from 'react';
import { Dialog } from '@ygtechnologies/rubus-ui';
import { SearchInput } from '@ygtechnologies/bygr-frontend-component-library';
import { Repo } from '@/services/systemHealth';
import shared from './SystemHealthPage.module.scss';
import theme from './ReposModal.module.scss';

const GITHUB = 'https://github.com/YGTechnologies';

/** The repo pages people jump to most. */
const pages: { label: string; path: string }[] = [
    { label: 'Code', path: '' },
    { label: 'Pull requests', path: '/pulls' },
    { label: 'Actions', path: '/actions' },
    { label: 'Commits', path: '/commits' },
    { label: 'Branches', path: '/branches' },
];

function timeAgo(date: Date, now: number) {
    const m = Math.max(0, Math.round((now - date.getTime()) / 60_000));
    if (m < 60) return `${m}m ago`;
    if (m < 1440) return `${Math.floor(m / 60)}h ago`;
    return `${Math.floor(m / 1440)}d ago`;
}

const ReposModal: React.FC<{ repos: Repo[]; now: number; onClose(): void }> = ({ repos, now, onClose }) => {
    const [search, setSearch] = useState('');
    const needle = search.trim().toLowerCase();
    const shown = repos.filter(
        (r) => !needle || r.name.toLowerCase().includes(needle) || r.description?.toLowerCase().includes(needle)
    );

    return (
        <Dialog open onOpenChange={(open) => !open && onClose()}>
            <Dialog.Content contentWidth="lg">
                <Dialog.Header>All repos ({repos.length})</Dialog.Header>
                <div className={theme.body}>
                    <SearchInput searchText={search} onSearchTextChange={setSearch} />
                    {shown.length === 0 ? (
                        <p className={shared.muted}>No repos match.</p>
                    ) : (
                        <ul className={theme.list}>
                            {shown.map((r) => (
                                <li key={r.name} className={theme.repo}>
                                    <div className={theme.main}>
                                        <a
                                            href={`${GITHUB}/${r.name}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={theme.name}>
                                            {r.name}
                                        </a>
                                        {r.description && <div className={shared.muted}>{r.description}</div>}
                                    </div>
                                    <nav className={theme.pages} aria-label={`${r.name} on GitHub`}>
                                        {pages.map((p) => (
                                            <a
                                                key={p.label}
                                                href={`${GITHUB}/${r.name}${p.path}`}
                                                target="_blank"
                                                rel="noreferrer">
                                                {p.label}
                                            </a>
                                        ))}
                                    </nav>
                                    <span className={`${shared.muted} ${theme.pushed}`}>
                                        {r.pushedAt ? `pushed ${timeAgo(r.pushedAt, now)}` : ''}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </Dialog.Content>
        </Dialog>
    );
};

export default ReposModal;
